/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Uploadfailederror2Inputs */

const en_uploadfailederror2 = /** @type {(inputs: Uploadfailederror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Upload failed. Please try again.`)
};

const de_uploadfailederror2 = /** @type {(inputs: Uploadfailederror2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hochladen fehlgeschlagen. Versuch's nochmal.`)
};

/**
* | output |
* | --- |
* | "Upload failed. Please try again." |
*
* @param {Uploadfailederror2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const uploadfailederror2 = /** @type {((inputs?: Uploadfailederror2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Uploadfailederror2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_uploadfailederror2(inputs)
	return de_uploadfailederror2(inputs)
});
export { uploadfailederror2 as "uploadFailedError" }